import { css } from '@emotion/react';

export const cellMaxWidth = (maxWidth) => css`
  max-width: ${maxWidth ?? '100px'};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
`;
